<template>
  <div>
    <b-row>
      <b-colxx xxs="12">
        <b-card class="mb-0" title="예약관리">
          <!----------------------------------  탭 ---------------------------------------------->
          <div class="resmTab">
            <ul>
              <li @click="tabClick(0)" :class="tab == 0 && 'on'">예약상품</li>
              <li @click="tabClick(1)" :class="tab == 1 && 'on'">시간설정</li>
              <li @click="tabClick(2)" :class="tab == 2 && 'on'">예약상품연결</li>
            </ul>
          </div>
          <!----------------------------------  탭 end ---------------------------------------------->

          <!----------------------------------  옵션설정 ---------------------------------------------->
          <div v-if="tab === 0">
            <div class="table-responsive p-0">
<!--              <b-table id="table-transition-example" :items="optionsetList" :fields="fields" striped small-->
<!--                       class="text-center" primary-key="optionCode" :tbody-transition-props="transProps" >-->
              <table id="table-transition-example" class="text-center" style="width: 100%">
                <colgroup>
                  <col width="*%"/>
                  <col width="7%"/>
                  <col width="10%" v-if="storeKakaoId" />
                  <col width="10%" v-if="storeKakaoId" />
                  <col width="*%"/>
                  <col width="7%"/>
                  <col width="7%"/>
                  <col width="7%"/>
                  <col width="5%"/>
                  <col width="5%"/>
                  <col width="5%"/>
                  <col width="5%"/>
                </colgroup>
                <thead>
                  <tr>
                    <th class="text-center" style="align-content: center" rowspan="2">상품명</th>
                    <th class="text-center" style="align-content: center" rowspan="2">유형</th>
                    <th class="text-center" style="align-content: center" rowspan="2" v-if="storeKakaoId">판매 채널</th>
                    <th class="text-center" style="align-content: center" rowspan="2" v-if="storeKakaoId">채널 추가 정보</th>
                    <th class="text-center" colspan="5">예약옵션</th>
                    <th class="text-center" style="align-content: center" rowspan="2">수정</th>
                    <th class="text-center" style="align-content: center" rowspan="2">노출 순서</th>
                    <th class="text-center" style="align-content: center" rowspan="2">삭제</th>
                  </tr>
                  <tr>
                    <th class="text-center">옵션명</th>
                    <th class="text-center">정상가</th>
                    <th class="text-center">판매가</th>
                    <th class="text-center">기준 인원</th>
                    <th class="text-center">권종</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(rmitem, rmidx) in optionsetList" :key="rmidx">
                    <td class="text-center">{{ rmitem.goodsName }}</td>
                    <td class="text-center">{{ rmitem.menuOptionType | opnameM }}</td>
                    <td class="text-center d-flex" style="justify-content: center; align-items: center" v-if="storeKakaoId">
                      <template v-for="tmpItem in rmitem.saleChannels ">
                        <div v-if="tmpItem == 'KAKAO' && storeKakaoId" class="mr-2" style=" width: 36px; height: 36px; background-color: #FEE500; border-radius: 4px; align-content: center" >
                          <img  src="/assets/img/kakao.png" height="25" width="25">
                        </div>
                        <div v-else class="mr-2" style=" width: 36px; height: 36px; background-color: red; border-radius: 4px; align-content: center" >
                          <img  src="/assets/img/logo_V.png" height="25" width="25">
                        </div>
                      </template>
                    </td>
                    <td class="text-center" v-if="storeKakaoId">
                      <b-button size="sm" class="btn-outline-dark" variant="white"
                              v-if="rmitem.saleChannels.filter(x=>x==='KAKAO').length>0"
                              @click="channelAdditionalModalOpen(rmitem.goodsCode)">수정
                      </b-button>
                    </td>
                    <td class="text-center">
                      <template v-for="tmpItem in rmitem.options.list ">
                        <div>
                          {{tmpItem.optionName}}
                        </div>
                      </template>
                    </td>
                    <td class="text-center">
                      <template v-for="tmpItem in rmitem.options.list ">
                        <div>
                          {{tmpItem.listPrice | numFormat}}
                        </div>
                      </template>
                    </td>
                    <td class="text-center">
                      <template v-for="tmpItem in rmitem.options.list ">
                        <div>
                          {{tmpItem.salePrice | numFormat}}
                        </div>
                      </template>
                    </td>
                    <td class="text-center">
                      <template v-for="tmpItem in rmitem.options.list ">
                        <div>
                          {{tmpItem.headCount }}
                        </div>
                      </template>
                    </td>
                    <td class="text-center">
                      <template v-for="tmpItem in rmitem.options.list ">
                        <div>
                          {{tmpItem.ageGroup | getTypeTextReturn}}
                        </div>
                      </template>
                    </td>
                    <td class="text-center">
                      <b-button size="sm" class="btn-outline-dark" variant="white"
                              @click="optionEdit(rmidx, rmitem.goodsCode)">수정
                      </b-button>
                    </td>
                    <td class="text-center">
                      <b-button-group vertical p-0>
                        <b-button variant="empty" class="header-icon btn-sm p-0"
                                  @click="optionUpDown(rmitem, rmidx, optionsetList, 'up')"
                                  :disabled="rmidx <= 0">
                          <b-icon icon="chevron-up" font-scale="1.5"></b-icon>
                        </b-button>
                        <b-button variant="empty" class="header-icon btn-sm p-0"
                                  @click="optionUpDown(rmitem, rmidx, optionsetList, 'down' )"
                                  :disabled="rmidx >= (optionsetList.length - 1)">
                          <b-icon icon="chevron-down" font-scale="1.5"></b-icon>
                        </b-button>
                      </b-button-group>
                    </td>
                    <td class="text-center">
                      <button class="btn btn-default"
                              @click="optionDel(rmitem.goodsCode)">
                        <b-icon-trash></b-icon-trash>
                      </button>
                    </td>
                  </tr>
                </tbody>

              </table>

            </div>
            <div class="right-btn">
              <button class="btn top-right-button btn-outline-success" @click="optionMake">예약상품 등록</button>
            </div>

          </div>
          <!----------------------------------  옵션설정 end ---------------------------------------------->

          <!----------------------------------  시간설정 ---------------------------------------------->
          <div v-if="tab === 1">
            <TimeSet />
          </div>
          <!----------------------------------  시간설정 end ---------------------------------------------->

          <!----------------------------------  옵션연결 ---------------------------------------------->
          <div v-if="tab === 2">
            <OptionConnection  @get-kakao-alert="getKakaoAlert"/>
          </div>
          <!----------------------------------  옵션연결 end ---------------------------------------------->

          <!----------------------------------  모달 ---------------------------------------------->
          <div class="modal" :style="optionModal && {'display': 'block'}">
            <div class="modal-dialog maxwid">
              <div class="modal-content">
                <div class="modal-header">{{ optionModalName }}</div>
                <div class="modal-body form-horizontal">
                  <b-row class="form-group newTitle">
                    <div class="col-sm-2">
                      상품명
                    </div>
                    <div class="col-sm-10">
                      <b-form-input v-model="menuGoods.goodsName" :rows="1" :max-rows="1" />
                      <span class="text-length-label">{{ getTextLength(menuGoods.goodsName) }} / 50 자</span>
                    </div>
                  </b-row>
                  <b-row class="form-group" v-if="storeKakaoId" >
                    <b-col cols="2">
                      판매 채널
                    </b-col>
                    <b-col cols="10" class="d-flex">
                      <b-form-checkbox class="mr-4" v-model="menuGoods.saleChannels" value='TABLENJOY'>테이블엔조이</b-form-checkbox>
                      <b-form-checkbox v-if="storeKakaoId" v-model="menuGoods.saleChannels"  value='KAKAO'>카카오톡 예약하기</b-form-checkbox>
                    </b-col>
                  </b-row>
                  <b-row class="form-group">
                    <b-col cols="2">
                      예약 유형
                    </b-col>
                    <b-col cols="10">
                      <div class="radio">
                        <label style="margin-right:10px">
                          <input type="radio" value="MenuBooking" v-model="menuGoods.menuOptionType" :disabled="optionModalName=='옵션 수정'" @change="onmenutRadio"/>
                          메뉴
                        </label>
                        <label>
                          <input type="radio" value="DepositBooking" v-model="menuGoods.menuOptionType" :disabled="optionModalName=='옵션 수정'" @change="onmenutRadio"/>
                          예약금
                        </label>
<!--                        <label>-->
<!--                          <input type="radio" value="PersonBooking" v-model="menuGoods.menuOptionType" :disabled="optionModalName=='옵션 수정'" @change="onmenutRadio"/>-->
<!--                          인원수-->
<!--                        </label>-->
<!--                        <label v-if="menuGoods.menuOptionType =='DepositBooking'" style="margin-right:10px">-->
<!--                          <input type="checkbox" ref="isDeposit" v-model="menuGoods.isDeposit" :value="false"  @change="saveDeposit" :disabled="optionModalName=='옵션 수정'"/>-->
<!--                          예약금 등록-->
<!--                        </label>-->
                      </div>
                    </b-col>
                  </b-row>
                  <b-row class="form-group newTitle">
                    <div class="col-sm-2">
                      예약 옵션
                    </div>
                    <div class="col-sm-10" v-if="menuGoods.menuOptionType == 'MenuBooking' || menuGoods.menuOptionType == 'DepositBooking'">
                      <b-button v-if="menuGoods.menuOptionType=='MenuBooking'" variant="white" type="button" class="btn btn-outline-dark" @click="menuSelectOpen" size="xs" style="float: right; margin-bottom: 8px;">메뉴선택</b-button>
                      <b-button v-else type="button" class="btn btn-outline-dark" variant="white" @click="menuLineAddit" size="xs" style="float: right; margin-bottom: 8px;">옵션추가</b-button>
                      <table class="table table-hover text-nowrap" style="margin-bottom:0px; margin-top: 4px">
                        <thead>
                        <tr>
                          <th class="text-center" v-if="menuGoods.menuOptionType=='MenuBooking'">메뉴코드</th>
                          <th class="text-center">옵션명</th>
                          <th class="text-center">정상가</th>
                          <th class="text-center">판매가</th>
                          <th class="text-center">기준 인원</th>
                          <th class="text-center">권종</th>
                          <th class="text-center">노출순서</th>
                          <th class="text-center">삭제</th>
                        </tr>
                        </thead>
                        <tbody class="scrollHeight">
                          <template v-if="selectedMenuOptions">
                            <tr v-for="(item, idx) in selectedMenuOptions " :key="idx" >
                              <td class="text-center" v-if="menuGoods.menuOptionType=='MenuBooking'">{{item.menuCode}}</td>
                              <td class="text-center">
                                <b-form-group>
                                  <b-form-input v-model="item.optionName" :rows="1" :max-rows="1" />
                                  <span class="text-length-label">{{ getTextLength(item.optionName) }} / 25 자</span>
                                </b-form-group>
                              </td>
                              <td class="text-center">
                                <input class="form-control newTitle" type="text" v-model="item.listPrice"
                                       style="max-width:100px;" readonly>
                              </td>
                              <td class="text-center">
                                <input class="form-control newTitle" type="text" v-model="item.salePrice"
                                       style="max-width:100px;" :disabled=" menuGoods.menuOptionType == 'PersonBooking' " @keyup="chkMenual( $event,idx)" />
                                <template
                                  v-if="percent(uncomma(item.listPrice) - uncomma(item.salePrice), uncomma(item.listPrice)) !== '0.00%' && menuGoods.menuOptionType == 'MenuBooking'">
                                  <span class="d-block" style="min-width: 150px; " v-if="Number(item.salePrice) !== 0">
                                    ({{
                                      percent(uncomma(item.listPrice) - uncomma(item.salePrice),
                                        uncomma(item.listPrice))
                                    }})
                                  </span>
                                </template>
                              </td>
                              <td class="text-center">
                                <input class="form-control newTitle" type="text" v-model="item.headCount"
                                       style="max-width:100px;" readonly>
                              </td>
                              <td class="text-center">
                                <div>
                                  <label >
                                    <input type="radio" value="Adult" v-model="item.ageGroup" />성인
                                  </label>
                                </div>
                                <div>
                                  <label >
                                    <input type="radio" value="Child" v-model="item.ageGroup" />소인
                                  </label>
                                </div>
                                <div>
                                  <label>
                                    <input type="radio" value="Baby" v-model="item.ageGroup" />
                                    유아
                                  </label>
                                </div>
                              </td>
                              <td class="text-center">
                                <b-button-group vertical p-0>
                                  <b-button variant="empty" class="header-icon btn-sm p-0"
                                            @click="menuUpDown(item, idx, selectedMenuOptions, 'up')"
                                            :disabled="idx <= 0">
                                    <b-icon icon="chevron-up" font-scale="1.5"></b-icon>
                                  </b-button>
                                  <b-button variant="empty" class="header-icon btn-sm p-0"
                                            @click="menuUpDown(item, idx, selectedMenuOptions, 'down')"
                                            :disabled="idx >= (selectedMenuOptions.length - 1)">
                                    <b-icon icon="chevron-down" font-scale="1.5"></b-icon>
                                  </b-button>
                                </b-button-group>
                              </td>
                              <td class="text-center">
                                <button class="btn btn-default"
                                        @click="menuDel(idx,item.optionCode)">
                                  <b-icon-trash></b-icon-trash>
                                </button>
                              </td>
                            </tr>
                          </template>
                        </tbody>
                      </table>
                    </div>
                  </b-row>

                </div>
                <div class="modal-footer text-center">
                  <button type="button" class="btn btn-outline-primary" @click="optionModalClose">취소</button>
                  <button type="button" class="btn mr-1 btn-primary" @click="optionModalSave" v-if="menuGoods.menuOptionType == 'MenuBooking' || menuGoods.menuOptionType == 'DepositBooking'">저장</button>
                </div>
              </div>
            </div>
          </div>
          <!----------------------------------  모달 end ---------------------------------------------->
          <!---------------------------------- 메뉴선택 모달 start ---------------------------------------------->
          <div class="modal" :style="menuSelect && {'display': 'block'}">
            <div class="modal-dialog maxwid">
              <div class="modal-content">
                <div class="modal-header">메뉴선택</div>
                <div class="modal-body form-horizontal">
                  <b-row class="form-group">
                    <div class="col-sm-12">
                      <div class="table-responsive tbl_h200 p-0 ">
                        <table class="table table-hover text-nowrap" style="margin-bottom:0px;">
                          <thead>
                          <tr>
                            <th class="text-center">선택</th>
                            <th class="text-center">메뉴코드</th>
                            <th class="text-center">메뉴명</th>
                            <th class="text-center">정상가</th>
                            <th class="text-center">기준 인원</th>
                          </tr>
                          </thead>
                          <tbody class="scrollHeight">
                            <tr v-for="(mitem, midx) in menuList" :key="midx"
                                @click="menuListTrClick(mitem.menuCode, midx)"
                                :style="menuListTrStyle(midx) && { 'background-color': '#D3E4F4' }">
                              <td v-if="!mitem.chevron"></td>
                              <td class="text-center" v-else>
                                <b-icon-chevron-down></b-icon-chevron-down>
                              </td>
                              <td class="text-center"> {{ mitem.menuCode }}</td>
                              <td class="text-center"> {{ mitem.menuName }}</td>
                              <td class="text-center"> {{ mitem.listPrice | numFormat }}</td>
                              <td class="text-center"> {{ mitem.headCount }}</td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </b-row>
                </div>
                <div class="modal-footer text-center">
                  <button type="button" class="btn btn-outline-primary" @click="menuSelectClose">취소</button>
                  <button type="button" class="btn mr-1 btn-primary" @click="menuSelectSave">저장</button>
                </div>
              </div>
            </div>
          </div>
          <!---------------------------------- 메뉴선택 모달 end ---------------------------------------------->
          <!---------------------------------- 채널 추가 정보 모달 start ---------------------------------------------->
          <div class="modal" :style="channelModalToggle && {'display': 'block'}">
            <div class="modal-dialog maxwid">
              <div class="modal-content">
                <div class="modal-header">채널 추가 정보</div>
                <div class="modal-body form-horizontal">
                  <b-row class="form-group ">
                    <div class="col-sm-2">
                      이용가능 연령
                    </div>
                    <div class="col-sm-10 d-flex" style="align-items: center">
                      <b-form-checkbox v-model="usableAgeToggle" :value='true'>이용 연령 제한</b-form-checkbox>
                      <span class="ml-5" v-if="usableAgeToggle">만</span>
                      <input class="form-control newTitle" type="text" v-if="usableAgeToggle" v-model="usableAge"
                             style="max-width:100px;">
                      <span v-if="usableAgeToggle">세</span>
                    </div>
                  </b-row>
                  <b-row class="form-group ">
                    <div class="col-sm-2">
                      유의사항
                    </div>
                    <div class="col-sm-10">
                      <textarea class="form-control" rows="5" maxlength="2000" v-model="notice" ></textarea>
                      <span class="mainIntroNum" >{{notice.length}}/ 2000 자</span>
                    </div>
                  </b-row>
                  <b-row class="form-group ">
                    <div class="col-sm-2">
                      이용안내
                    </div>
                    <div class="col-sm-10">
                      <textarea class="form-control" rows="5" maxlength="2000" v-model="useInformation" ></textarea>
                      <span class="mainIntroNum" >{{useInformation.length}}/ 2000 자</span>
                    </div>
                  </b-row>
                  <b-row class="form-group ">
                    <div class="col-sm-2">
                      상품 이미지
                    </div>
                    <div class="col-sm-10">
<!--                      <button class="btn btn-outline-dark"-->
<!--                              @click="storeImage1ModalOpen('kakao')">매장 이미지에서 선택-->
<!--                      </button>-->
                      <b-form-row>
                        <sortable-file-uploader :sortable="'hold'" :container="'STORE'" :compact="false" :maxFiles="10" :defaultFiles="tempKakaoContent" @getFileData="getKakaoGoodsFiles"></sortable-file-uploader>
                      </b-form-row>
                      <label class="col-sm-12 control-label mt-2">
                        • 미등록 시 카카오톡 예약하기 장소 대표 이미지로 대체되어 등록됩니다.<br/>
                        • 이미지는 최대 10개 까지 등록 가능합니다.
                      </label>
                    </div>
                  </b-row>
                  <b-row class="form-group ">
                    <div class="col-sm-2">
                      상품 설명 이미지
                    </div>
                    <div class="col-sm-10">
<!--                      <button class="btn btn-outline-dark"-->
<!--                              @click="storeImage1ModalOpen('description')">매장 이미지에서 선택-->
<!--                      </button>-->
                      <b-form-row>
                        <sortable-file-uploader :sortable="'handle'" :container="'STORE'" :compact="false" :maxFiles="10" :defaultFiles="tempDescriptionContent" @getFileData="getDescriptionFiles"></sortable-file-uploader>
                      </b-form-row>
                      <label class="col-sm-12 control-label mt-2">
                        • 미등록 시 카카오톡 예약하기 장소 대표 이미지로 대체되어 등록됩니다.<br/>
                        • 이미지는 최대 10개 까지 등록 가능합니다.
                      </label>
                    </div>
                  </b-row>
                </div>
                <div class="modal-footer text-center">
                  <button type="button" class="btn btn-outline-primary" @click="channelAdditionalModalClose">취소</button>
                  <button type="button" class="btn mr-1 btn-primary" @click="channelAdditionalModalSave">저장</button>
                </div>
              </div>
            </div>
          </div>

<!--          <div class="modal" :style="storeImage1Toggle && {'display': 'block'}">-->
<!--            <div class="modal-dialog maxwid">-->
<!--              <div class="modal-content">-->
<!--                <div class="modal-header border-bottom-0">추가 이미지</div>-->
<!--                <div class="modal-body addmodals">-->
<!--                  <div class="addimgInputGroup">-->
<!--                    <div class="form-group">-->
<!--                      <label class="control-label">설명</label>-->
<!--                      <input type="text" class="form-control" v-model="tempSubContent.description" />-->
<!--                    </div>-->

<!--                    <div class="form-group">-->
<!--                      <StoreFileUpLoad ref="subImages" :newsubimguse="true" :fakeIndex="fakeIndex"-->
<!--                                       @newimgadd="newsubimgstoreadd " :subImagesBtnType='subImagesBtnType'-->
<!--                                       :defaultFiles="tempSubContent2.images" :reqImgBackground2="reqImgBackground2"-->
<!--                                       :container="'STORE'" @getFileData="subImageHandling2"></StoreFileUpLoad>-->
<!--                    </div>-->
<!--                  </div>-->
<!--                  <div class="imgBoxDivGroup">-->
<!--                    <div class="imgDragbox" style="background: #dedede;">-->
<!--                      <ul class="titleArr">-->
<!--                        <li class="cls_click" v-for="(titem,idx) in titleArr" :key="idx"-->
<!--                            @click="titleArrClcik(titem)">-->
<!--                          <a>{{ titem.title }}</a>-->
<!--                        </li>-->
<!--                      </ul>-->
<!--                      <div>-->
<!--                        <ul class="tab">-->
<!--                          <li v-for="title in storeTitleList" :key="title">{{ title }}</li>-->
<!--                        </ul>-->
<!--                      </div>-->
<!--                      <div id="holder" class="dropImgBox" v-on:dragover=" allowDrop" v-on:drop="ondrop($event,1)"-->
<!--                           @dragenter="onDragenter" style="width:100%;height:400px">-->
<!--                        <img v-for="(img,idx) in imgDragList" :key="idx" class="imgboxChild" :src="img.url"-->
<!--                             :width="img.width" :height="img.height" draggable="true" v-on:dragstart="drag"-->
<!--                             :id="'imgidx'+idx">-->
<!--                      </div>-->
<!--                    </div>-->
<!--                  </div>-->
<!--                </div>-->
<!--                <div class="modal-footer text-center">-->
<!--                  <button type="button" class="btn btn-outline-primary" @click="storeImage1ModalClose">취소</button>-->
<!--                  <button type="button" class="btn mr-1 btn-primary" @click="storeImage1ModalSave">저장</button>-->
<!--                </div>-->
<!--              </div>-->
<!--            </div>-->

<!--          </div>-->
        </b-card>
      </b-colxx>
    </b-row>
  </div>
</template>

<script>
import {
  getPercent
} from '../../utils/index';
import {
  rescode,
} from "../../constants/common";
import {
  reqGet,
  reqPost
} from "../../constants/request";

import api from '../../constants/api'
import {
  mapGetters,
  mapActions
} from "vuex";
import TimeSet from '../../components/Pages/TimeSet.vue';
import OptionConnection from '../../components/Pages/OptionConnection.vue';
import StoreImg2 from '../../views/shop/components/StoreImg2.vue';
import AvailableStore from "@/views/goods/components/edit/AvailableStore.vue";
import StoreFileUpLoad from "@/components/Upload/StoreFileUpLoad.vue";
import SortableFileUploader from "@/components/Upload/SortableFileUploader.vue";
import SubImageContentViewer from "@/views/goods/components/edit/SubImageContentViewer.vue";
import StoreImg from "@/views/shop/components/StoreImg.vue";


export default {
  components: {
    StoreImg,
    'sub-image-content-viewer': SubImageContentViewer,
    StoreFileUpLoad, AvailableStore,
    'sortable-file-uploader': SortableFileUploader,
    TimeSet,
    OptionConnection,
    StoreImg2
  },
  computed: {
    ...mapGetters(['currentUser', 'siteName'])
  },
  data() {
    return {
      transProps: {
        name: 'list'
      },

      userRole: null,
      edtss: false,
      optionCode: '',
      tab: 0,
      menutRadio: false,
      optionMakeModal: false,
      optionModal: false,
      storeCode: this.$route.params.storeCode,
      optionModalName: "",
      menuList: [],
      optionsetList: [],
      mOpName: "",
      mNprice: "",
      mPrice: 0,
      mPersonnel: "",
      clickMenuCode: "",
      token: '',
      tempMenupanContent: [],
      ageGroup: 'Adult',
      menuSelect:false,
      channelModalToggle:false,
      kakaoGoodsImage:"",
      kaKaoGoodsImages:[],
      descriptionImages:[],
      storeImage1Toggle:false,

      menuGoods:{
        goodsName:"",
        saleChannels:['TABLENJOY'],
        menuOptionType:"MenuBooking",
        isDeposit:true,
      },
      menuOptions:[],
      usableAge:0,
      useInformation:"",
      notice:"",
      addStoreImgUse:false,
      imgDragList:[],
      titleArr:[],
      storeTitleList:[],
      selectedMenuOptions:[],
      tmpSelectedMenuOptions:[],
      kakaoGoodsId: "",
      kkoOrDesToggle:"",
      fakeIndex:[],
      subImagesBtnType: '',
      tempSubContent2: {
        id: 0,
        title: null,
        description: null,
        images: [{
          "width": 0,
          "height": 0,
          "url": null,
          "azureUrl": null,
          "description":""
        }]
      },
      reqImgBackground2: [{
        "width": 0,
        "height": 0,
        "url": null,
        "azureUrl": null,
        "description":""
      }],
      tempSubContent:[],
      tempKakaoContent:[],
      tempDescriptionContent:[],
      spinning:false,
      ReflectVal: null,
      tempMainContent: [],
      tempMainContent2: [],
      _mainImage:[],
      _mainImage2:[],
      usableAgeToggle:false,
      menuGoodsCode:-1,
      storeKakaoId:null,
      deleteOptionIds:[],
      channelGoodsId:0,

    }
  },

  watch: {
    menutRadio(val) {
      if (val) {
        if (this.optionModalName === '옵션 수정') {
          if (this.edtss === true) {

          } else {
            this.mPrice = 0;
          }
        }
        this.mPersonnel = 1;
      } else {
        if (this.optionModalName === '옵션 수정') {
          if (this.edtss === true) {

          } else {
            this.mPrice = 0;
          }
        }
        let mme = this.menuList.find((menu) => {
          return menu.chevron === true;
        })
        // console.log(mme)
        if (mme === undefined && this.menutRadio === false) {
          this.mPersonnel = "";
        } else {
          this.mPersonnel = this.mPersonnelCopy;
        }

      }
      this.edtss = false;
    }
  },
  filters: {
    getTypeTextReturn(type) {
      if (type == 'Adult') {
        return '성인';
      } else if (type == 'Child') {
        return '소인';
      } else {
        return '유아';
      }
    },
    opnameM(val) {
      if (val == 'DepositBooking') {
        return '예약금'
      } else {
        return '메뉴'
      }
    }
  },
  mounted() {
    this.refresh();
    this.optiionEdtReq();
    this.userRole = this.currentUser.userRole.split('_')[0];
    if(this.storeKakaoId){
      this.menuGoods.saleChannels = ['TABLENJOY','KAKAO']
    }else{
      this.menuGoods.saleChannels = ['TABLENJOY']
    }
    // this.storeImgList();
  },
  methods: {
    optionUpDown(item, idx, optionSetList, type) {
      if (Number(idx) === 0 && type === 'up') {
        return;
      }
      if (Number(idx) === (optionSetList.length - 1) && type === 'down') {
        return;
      }
      let newOptionSetList1 = [];
      for (const idx2 in optionSetList) {
        newOptionSetList1.push({
          goodsId: optionSetList[idx2].goodsCode,
          sortNumber: optionSetList[idx2].sortNumber,
        })
      }
      let newOptionSetList = JSON.parse(JSON.stringify(newOptionSetList1));
      if (type === 'up') {
        newOptionSetList.splice(Number(idx) - 1, 0, newOptionSetList[idx])
        newOptionSetList.splice(Number(idx) + 1, 1)
      } else {
        newOptionSetList.splice(Number(idx), 2, newOptionSetList[idx + 1], newOptionSetList[idx])
      }

      let number = 0;
      for (const listIdx in newOptionSetList) {
        newOptionSetList[listIdx].sortNumber = number += 1
      }
      // console.log(newOptionSetList)
      let reqURL = ''
      console.log(this.userRole)
      if (this.userRole == "BRAND") {
        reqURL = api.changeAPI(this.siteName, api.basicURL + api.shop.soterOprionNumUpdateBrd)
      } else {
        reqURL = api.changeAPI(this.siteName, api.basicURL + api.shop.soterOprionNumUpdateStr)
      }

      const params = {
        sortNumberList: newOptionSetList,
        storeCode: this.$route.params.storeCode
      }
      // console.log(params)
      this.$http.post(reqURL, params, {
        headers: {
          'Authorization': `Bearer ${this.currentUser.tokens.access.token}`
        }
      }).then(res => {
        if (res.data.code === "OK") {

          this.refresh();

        } else {
          throw 400
        }
      }).catch(err => {
        alert(err.response.data.message);
      })
    },
    changeNum: function (value) {
      return value = this.comma(this.uncomma(value));
    },
    comma(str) {
      str = String(str);
      return str.replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")
    },
    uncomma(str) {
      str = String(str);
      return str.replace(/[^\d]+/g, '');
    },
    refresh() {


      reqGet(
        this.requrlChange(api.shop.kakaoStoreOptionlListBrd, api.shop.kakaoStoreOptionlListStr, '?storeCode=' + this.storeCode, ''),
        this.currentUser.tokens.access.token,
        (result) => {
          if (result != null) {
            if (result.code == rescode.REQ_SUCCESS) {
              this.optionsetList = result.data.list;
              this.storeKakaoId = result.data.storeKakaoId
            } else {
              alert(result.message);
            }
          }
        }
      );
    },
    optionDel(optionCode) {
      if (confirm("삭제하시겠습니까? 예약시간에 연결된 옵션 모두 삭제됩니다.")) {
        reqPost(
          this.requrlChange(api.shop.storeOptionlDeleteBrd, api.shop.storeOptionlDeleteStr, '', ''),
          this.currentUser.tokens.access.token, {
            "goodsId": optionCode,
            "storeCode": this.storeCode,
          },
          (result) => {
            if (result != null) {
              if (result.code == rescode.REQ_SUCCESS) {

                this.refresh();
              } else {
                alert(result.message);
              }
            }
          }
        );
      }
    },
    optionModalSave() {
      // let mme = this.menuList.find((menu) => {
      //   return menu.chevron === true;
      // })
      // if (mme === undefined && this.menutRadio === false) {
      //   alert('메뉴를 선택 해주세요.');
      //   return;
      // }
      // if (this.mOpName === "") {
      //   alert('옵션명을 적어주세요.');
      //   return;
      // }
      // if (this.mPrice === '') {
      //   alert('판매가를 적어주세요.');
      //   return;
      // }

      let menuCode = null;

      if(this.selectedMenuOptions.length>10) {
        alert("예약 옵션은 최대 10개까지 등록 가능합니다.")
        return
      }else if(this.selectedMenuOptions.length==0){
        alert("예약 옵션을 선택해 주세요")
        return
      }
      let chkValid = true
      let errmsg = ''
      if(this.menuGoods.goodsName.length ==0){
        alert('상품명을 입력해주세요');
        return;
      }else if(this.menuGoods.saleChannels.length ==0){
        alert('판매채널을 입력해주세요');
        return;
      }else if(!this.menuGoods.menuOptionType){
        alert('예약유형을 선택해주세요.');
        return;
      }

      for(let i = 0 ; i<this.selectedMenuOptions.length; i++){
        let item = this.selectedMenuOptions[i]
        if(item.optionName.length ==0){
          chkValid = false;
          errmsg = '옵션명을 입력해 주세요'
          break;
        }else if(!item.ageGroup){
          chkValid = false;
          errmsg = '권종을 입력해 주세요'
          break;
        }else if(Number(item.salePrice)<1 && this.menuGoods.menuOptionType=='MenuBooking'){
          chkValid = false;
          errmsg = '판매가를 1원 이상 입력해 주세요'
          break;
        }else if(Number(item.salePrice)<1 && this.menuGoods.menuOptionType=='DepositBooking'){
          chkValid = false;
          errmsg = '판매가를 1원 이상 입력해 주세요'
          break;
        }else if(Number(item.salePrice) != 0 && this.menuGoods.menuOptionType=='PersonBooking' ){
          chkValid = false;
          errmsg = '판매가는 0원이 필수입니다.'
          break;
        }
      }

      // DepositBooking
      if(!chkValid){
        alert(errmsg);
        return;
      }



      let param = {};
      this.selectedMenuOptions.forEach(item=>{
        item.menuOptionType = this.menuGoods.menuOptionType
      })
      // if (this.menutRadio === false) { //메뉴
      let reqURL = ''
      if (this.optionModalName === '옵션 수정') {
        reqURL = this.requrlChange(api.shop.kakaoStoreOptionlUpdateBrd, api.shop.kakaoStoreOptionlUpdateStr, '', '')
        param = {
          deleteOptionIds:this.deleteOptionIds,
          menuGoods: {
            goodsName: this.menuGoods.goodsName,
            menuOptionType: this.menuGoods.menuOptionType,
            saleChannels: this.menuGoods.saleChannels,
            isDeposit: this.menuGoods.isDeposit,
          },
          menuOptions:this.selectedMenuOptions,
          storeCode: this.storeCode,
          menuGoodsCode:this.menuGoodsCode
        }
      } else {
        reqURL = this.requrlChange(api.shop.kakaoStoreOptionlCreateBrd, api.shop.kakaoStoreOptionlCreateStr, '', '')
        param = {
          menuGoods: {
            goodsName: this.menuGoods.goodsName,
            menuOptionType: this.menuGoods.menuOptionType,
            saleChannels: this.menuGoods.saleChannels,
            isDeposit: this.menuGoods.isDeposit,
          },
          menuOptions:this.selectedMenuOptions,
          storeCode: this.storeCode,
        }
      }
      // } else {
      //   param = {
      //     menuOption: {
      //       optionName: this.mOpName,
      //       menuOptionType: this.menutRadio ? 'DepositBooking' : 'MenuBooking',
      //       salePrice: this.uncomma(this.mPrice),
      //       ageGroup: this.ageGroup,
      //     },
      //     storeCode: this.storeCode,
      //     optionCode: this.optionCode,
      //   };
      // }

      // this.optionsetList.push(param);
      reqPost(
        reqURL,
        this.currentUser.tokens.access.token,
        param,
        (result) => {
          if (result != null) {
            if (result.code == rescode.REQ_SUCCESS) {
              this.menuGoodsCode = -1
              // this.refresh();

              alert('저장되었습니다.');
              this.menuGoods.goodsName= ""
              this.menuGoods.menuOptionType= "MenuBooking"
              if(!this.storeKakaoId){
                this.menuGoods.saleChannels = ['TABLENJOY']
              }else{
                this.menuGoods.saleChannels = ['TABLENJOY','KAKAO']
              }
              // this.menuGoods.isDeposit= true
              this.selectedMenuOptions = []
              this.tmpSelectedMenuOptions=[]
              this.menuGoodsCode = -1
              this.deleteOptionIds=[]
              this.refresh();
            } else {
              alert(result.message);
            }
          }
        }
      );
      this.optionModal = false;
    },
    menuListTrClick(code, idx) {
      if (this.menuList[idx].chevron === true) {
        this.menuList[idx].chevron = false;
        let tmpIdx = this.tmpSelectedMenuOptions.findIndex(x => x.menuCode == code)
        console.log("chevron true tmpidx = " + tmpIdx)
        if(tmpIdx>-1){
          this.tmpSelectedMenuOptions.splice(tmpIdx,1);
        }
        this.$forceUpdate()
      } else {
        // this.menuList.forEach(el => {
        //   el.chevron = false;
        // });
        this.menuList[idx].chevron = true;
        var tmp = {
          optionName: this.menuList[idx].menuName,
          salePrice: this.changeNum(this.menuList[idx].salePrice),
          ageGroup : "",
          menuCode:this.menuList[idx].menuCode,
          listPrice: this.changeNum(this.menuList[idx].listPrice),
          headCount:this.menuList[idx].headCount,
          sortNumber:this.tmpSelectedMenuOptions.length,
        }
        let tmpIdx = this.tmpSelectedMenuOptions.findIndex((x)=>{x.menuCode == code})
        console.log("else tmpidx = " + tmpIdx)
        if(tmpIdx == -1){
          this.tmpSelectedMenuOptions.push(tmp)
        }
        this.$forceUpdate()


      }
    },
    menuListTrStyle(midx) {
      if (this.menuList[midx].chevron === true) {
        return true
      } else {
        return false
      }
    },
    optionMake() {
      this.optionModal = true;
      this.menutRadio = false;
      this.optionModalName = '예약상품 등록';
      this.menuList.forEach(menu => {
        menu.chevron = false;
      });
      this.mOpName = '';
      this.ageGroup = 'Adult';
      this.listPrice = '';
      this.mPrice = '';
      this.mPersonnel = '';
      if(!this.storeKakaoId){
        this.menuGoods.saleChannels = ['TABLENJOY']
      }else{
        this.menuGoods.saleChannels = ['TABLENJOY','KAKAO']
      }
    },
    optiionEdtReq() {
      reqGet(
        this.requrlChange(api.shop.storeMenuListBrd, api.shop.storeMenuListStr, "?storeCode=" + this.storeCode, ''),
        this.currentUser.tokens.access.token,
        (result) => {
          if (result != null) {
            if (result.code == rescode.REQ_SUCCESS) {
              this.menuList = result.data.list;
              this.menuList.forEach(el => {
                el.push({
                  chevron: false
                })
              });
            } else {
              alert(result.message);
            }
          }
        }
      );
    },
    optionEdit(rmidx, optionCode) {
      this.optionCode = optionCode;
      this.optionModal = true;
      this.optionModalName = '옵션 수정';
      this.menuGoodsCode = optionCode
      // this.menuList.forEach(menu => {
      //     menu.chevron = false;
      // });
      reqGet(
        this.requrlChange(api.shop.kakaoStoreOptionlQueryBrd, api.shop.kakaoStoreOptionlQueryStr, "?storeCode=" + this.storeCode + "&menuGoodsCode=" + optionCode, "?menuGoodsCode=" + optionCode),
        this.currentUser.tokens.access.token,
        (result) => {
          if (result != null) {
            if (result.code == rescode.REQ_SUCCESS) {
              this.menuList.forEach((el, idx) => {
                if (result.data.menuCode == el.menuCode) {
                  this.menuList[idx].chevron = true;
                } else {
                  el.chevron = false;
                }
              });
              console.log(this.menuList)
              // let vm = this;
              // vm.menutRadio = result.data.menuOptionType === "DepositBooking" ? true : false;
              // // console.log(result.data)
              // vm.mOpName = result.data.optionName;
              // vm.mNprice = this.comma(result.data.listPrice);
              // vm.mPrice = this.comma(result.data.salePrice);
              // vm.clickMenuCode = result.data.menuCode;
              // console.log(result.data.salePrice)
              // vm.mPersonnel = result.data.headCount;
              // vm.mPersonnelCopy = result.data.headCount;
              this.menuGoods.goodsName= result.data.goodsName
              this.menuGoods.menuOptionType= result.data.menuOptionType
              this.menuGoods.saleChannels= result.data.saleChannels
              // this.menuGoods.isDeposit= result.data.isDeposit
              this.selectedMenuOptions = result.data.options.list
              this.selectedMenuOptions.forEach(item=>{
                item.newOption = false
                item.updateOptionId = item.optionCode
              })
            } else {
              alert(result.message);
            }
          }
        }
      );
      this.edtss = true;
    },
    optionModalClose() {
      this.menuGoods.goodsName= ""
      this.menuGoods.menuOptionType= "MenuBooking"
      if(this.storeKakaoId){
        this.menuGoods.saleChannels = ['TABLENJOY','KAKAO']
      }else{
        this.menuGoods.saleChannels = ['TABLENJOY']
      }
      // this.menuGoods.isDeposit= true
      this.selectedMenuOptions = []
      this.tmpSelectedMenuOptions=[]
      this.menuGoodsCode = -1
      this.optionModal = false;
    },
    onmenutRadio() {
      this.selectedMenuOptions = []
    },
    tabClick(tabidx) {
      if (tabidx === 0) {
        this.tab = 0;
      } else if (tabidx === 1) {
        this.tab = 1;
      } else {
        this.tab = 2;
      }
    },
    percent(nval, oval) {
      return getPercent(nval, oval);
    },
    requrlChange(brdapiName, strapiName, brdquerystring, strquerystring) {
      let reqURL = ''
      if (this.currentUser.userRole.split('_')[0] == "BRAND") {
        reqURL = api.changeAPI(this.siteName, api.basicURL + brdapiName) + brdquerystring
      } else {
        reqURL = api.changeAPI(this.siteName, api.basicURL + strapiName) + strquerystring
      }
      return reqURL
    },
    channelAdditionalModalOpen(val){

      reqGet(
        this.requrlChange(api.shop.kakaoStoreAdditionalQueryBrd, api.shop.kakaoStoreAdditionalQueryStr, "?storeCode=" + this.storeCode+ "&menuGoodsCode=" + val, "?storeCode=" + this.storeCode+ "&menuGoodsCode=" + val),
        this.currentUser.tokens.access.token,
        (result) => {
          if (result != null) {
            if (result.code == rescode.REQ_SUCCESS) {
              console.log(result.data)
              this.kakaoGoodsId = result.data.kakaoGoodsId;
              this.usableAge = result.data.usableAge
              this.useInformation = result.data.useInformation
              this.kaKaoGoodsImages = result.data.kaKaoGoodsImages
              this.notice = result.data.notice
              this.descriptionImages = result.data.descriptionImages
              this.channelGoodsId = Number(val);
              if(this.usableAge != 0 ){
                this.usableAgeToggle = true;
              }

              const vm = this
              this.kaKaoGoodsImages.forEach((val, index) =>{
                vm.tempKakaoContent.push({
                  "name": "TestName.jpg",
                  "size": 20000,
                  "type": "image/jpeg",
                  "ext": "jpg",
                  "url": val.url,
                  "height": val.height,
                  "width": val.width
                })
              })
              this.descriptionImages.forEach((val, index) =>{
                vm.tempDescriptionContent.push({
                  "name": "TestName.jpg",
                  "size": 20000,
                  "type": "image/jpeg",
                  "ext": "jpg",
                  "url": val.url,
                  "height": val.height,
                  "width": val.width
                })
              })
            } else {
              alert(result.message);
            }
          }
        }
      );
      this.channelModalToggle = true
    },
    channelAdditionalModalClose(){
      this.kakaoGoodsId = "";
      this.usableAge = ""
      this.useInformation = ""
      this.kaKaoGoodsImages = []
      this.notice = ""
      this.descriptionImages = []
      this.channelModalToggle = false
      this.tempKakaoContent = [];
      this.tempDescriptionContent = [];
      this.usableAgeToggle = false;
      this.channelGoodsId = 0;
    },
    menuUpDown(item, idx, optionSetList, type) {
      if (Number(idx) === 0 && type === 'up') {
        return;
      }
      if (Number(idx) === (optionSetList.length - 1) && type === 'down') {
        return;
      }
      let newOptionSetList1 = [];
      console.log(optionSetList)
      for (const idx2 in optionSetList) {
        newOptionSetList1.push({
          optionName: optionSetList[idx2].optionName, //
          salePrice: optionSetList[idx2].salePrice, //
          ageGroup : optionSetList[idx2].ageGroup, //
          menuCode:optionSetList[idx2].menuCode,
          listPrice: optionSetList[idx2].listPrice,
          headCount:optionSetList[idx2].headCount,
          sortNumber:optionSetList[idx2].sortNumber,
          newOption:optionSetList[idx2].newOption,
          updateOptionId:optionSetList[idx2].updateOptionId,

        })
      }
      console.log(newOptionSetList1)
      let newOptionSetList = JSON.parse(JSON.stringify(newOptionSetList1));
      if (type === 'up') {
        newOptionSetList.splice(Number(idx) - 1, 0, newOptionSetList[idx])
        newOptionSetList.splice(Number(idx) + 1, 1)
      } else {
        newOptionSetList.splice(Number(idx), 2, newOptionSetList[idx + 1], newOptionSetList[idx])
      }

      let number = 0;
      for (const listIdx in newOptionSetList) {
        newOptionSetList[listIdx].sortNumber = number += 1
      }

      this.selectedMenuOptions = newOptionSetList
      this.$forceUpdate()
    },
    menuSelectOpen(){
      //여기
      this.menuList.forEach(menu => {
        menu.chevron = false;
      });
      this.menuSelect = true

    },
    menuSelectClose(){
      this.tmpSelectedMenuOptions=[]
      this.menuSelect = false
    },
    menuSelectSave(){

      if(this.tmpSelectedMenuOptions.length + this.selectedMenuOptions.length>10){
        alert("예약 옵션은 최대 10개까지 등록 가능합니다.")
        return
      }else{
        this.selectedMenuOptions.forEach((item,idx)=>{
          item.sortNumber = idx+1
        })
        this.tmpSelectedMenuOptions.forEach(item2=>{
          item2.newOption = true
          item2.sortNumber = this.selectedMenuOptions.length+1
          // item2.updateOptionId = item2.menuCode
          this.selectedMenuOptions.push(item2)
        })

        this.tmpSelectedMenuOptions = []

        this.$forceUpdate()
        this.menuSelect = false
      }
    },
    channelAdditionalModalSave(){

      if(this.usableAgeToggle == false){
        this.usableAge = 0
      }

      this.kaKaoGoodsImages.forEach((item, idx )=>{

        item.priority = idx
        // item.description = !this.tempKakaoContent[idx].description ? "" : this.tempKakaoContent[idx].description
      })
      this.descriptionImages.forEach((item, idx )=>{
        item.priority = idx
        // item.description = !this.tempDescriptionContent[idx].description ? "" : this.tempDescriptionContent[idx].description
      })

      let reqData = {
        goodsId: this.channelGoodsId,
        usableAge: this.usableAge,
        useInformation: this.useInformation,
        notice:this.notice,
        kaKaoGoodsImages: this.kaKaoGoodsImages,
        descriptionImages: this.descriptionImages,
      }
      let reqURL = ""
      reqURL = api.changeAPI(this.siteName, api.basicURL + api.shop.updateKakaoGoodsAdditionalInfo)
      this.$http.post(reqURL, reqData, {
        headers: {
          'Authorization': `Bearer ${this.currentUser.tokens.access.token}`
        }
      }).then(res => {
        this.channelModalToggle = false;

        this.kakaoGoodsId = "";
        this.usableAge = ""
        this.useInformation = ""
        this.kaKaoGoodsImages = []
        this.notice = ""
        this.descriptionImages = []
        this.tempKakaoContent = [];
        this.tempDescriptionContent = [];
        this.channelGoodsId = 0;
        this.usableAgeToggle = false;
        this.refresh();
      })

      this.channelModalToggle = false;
    },
    menuDel(idx,code){
      this.deleteOptionIds.push(code)
      this.selectedMenuOptions.splice(idx,1);
      this.selectedMenuOptions.forEach((item,idx)=>{
        item.sortNumber = idx+1
      })
      this.$forceUpdate();
    },
    getKakaoGoodsFiles(fileData) { //서브이미지 파일 목록 SortableFileUploader 에서 넘겨줌
      // this.fileForm.subFiles = fileData

      if (fileData.length > 0) {
        let vm = this
        this.kaKaoGoodsImages = []

        fileData.forEach(function (value, index) {
          let _url = value.azureUrl ? value.azureUrl : value.url;

          vm.kaKaoGoodsImages.push({
            priority: index+1,
            width: value.width,
            height: value.height,
            url: _url,
            azureUrl: _url
          })
        })

      } else {
        this.kaKaoGoodsImages = []
      }


    },
    getDescriptionFiles(fileData) { //서브이미지 파일 목록 SortableFileUploader 에서 넘겨줌

      if (fileData.length > 0) {
        let vm = this
        this.descriptionImages = []

        fileData.forEach(function (value, index) {
          let _url = value.azureUrl ? value.azureUrl : value.url;

          vm.descriptionImages.push({
            priority: index+1,
            width: value.width,
            height: value.height,
            url: _url,
            azureUrl: _url
          })
        })

      } else {
        this.descriptionImages = []
      }

    },

    // storeImgList() {
    //   reqGet(
    //     this.requrlChange(api.shop.storeImageslistBRD, api.shop.storeImageslistSTR, "?storeCode=" + this.storeCode, "?storeCode=" + this.storeCode),
    //     this.currentUser.tokens.access.token,
    //     (result) => {
    //       if (result != null) {
    //         if (result.code == rescode.REQ_SUCCESS) {
    //           this.imgDragList = [];
    //           this.imgDragListOriginal = [];
    //           // console.log(result.data.list)
    //           this.titleArr = [];
    //           //titleArr
    //           result.data.list.forEach(el => {
    //             // console.log(.url)
    //             this.titleArr.push({
    //               title: el.title,
    //               storeImages: el.storeImages
    //             })
    //             this.imgDragListOriginal = JSON.parse(JSON.stringify(this.imgDragList));
    //           });
    //           this.titleArrClcik(result.data.list[0]);
    //         } else {
    //           alert(result.message);
    //         }
    //       }
    //     }
    //   );
    // },

    chkMenual(val,idx) {
      // console.log(val.target._value)
      this.selectedMenuOptions[idx].salePrice = val.target._value;
      if (this.menuGoods.menuOptionType == 'DepositBooking') {
        this.selectedMenuOptions[idx].listPrice = val.target._value;
      }


    },
    menuLineAddit(){
      let length = this.selectedMenuOptions.length
      if(length==10){
        alert("예약 옵션은 최대 10개까지 등록 가능합니다.")
        return
      }
      this.selectedMenuOptions.forEach((item,idx)=>{
        item.sortNumber = idx+1
      })
      this.selectedMenuOptions.push({
        optionName: "", //
        salePrice: "", //
        ageGroup : "Adult", //
        listPrice: "",
        headCount:1,
        sortNumber:Number(length+1),
        newOption:true,
      })
      this.$forceUpdate()
    },

    getKakaoAlert(val){
      this.$emit('get-kakao-alert', 'RESERVATION');
    },
    getTextLength(str) {
      return (!str || str.length === 0) ? 0 : str.length;
    },

  }
}
</script>

<style scoped>
th {
  background-color: #dee2e685;
}


.table>thead>tr>th {
  height: 50px;
  vertical-align: middle;
}

.table>tbody>tr>td {
  vertical-align: middle;
}

#colored {
  color: blue;
}

.modal-body.addmodals {
  display: flex;
  justify-content: space-between;
}
.modal-body.addmodals .imgBoxDivGroup {
  width: 50%;
}
.addimgInputGroup {
  width: 45%;
  vertical-align: top;
}

.modal-body.addmodals .imgBoxDivGroup .imgDragbox {
  width: 100%;
}

.dropImgBox::-webkit-scrollbar {
  width: 6px;
}

.dropImgBox::-webkit-scrollbar-track {
  background-color: grey;
}

.dropImgBox::-webkit-scrollbar-thumb {
  background-color: #2f3542;
}

.dropImgBox {
  height: 400px;
  text-align: left;
  overflow: auto;
}
ul .tab li {
  list-style: none;
  display: inline-block;
  border-bottom: 1px solid #337ab7;
  margin-left: 15px;
  color: #337ab7;
  cursor: pointer;
}

ul.titleArr {
  margin: 0;
  text-align: left;
  padding: 0;
  margin-left: 14px;
}
ul.titleArr li {
  list-style: none;
  display: inline-block;
  margin-left: 10px;
  cursor: pointer;
}

ul.titleArr li:first-child {
  margin: 0;
}
.imgBoxDivGroup {
  display: flex;
  width: 100%;
  justify-content: center;
}

.imgboxChild:nth-child(1n) {
  margin-right: 10px;
}

.imgBoxDivGroup>div .imgboxChild {
  height: 200px;
  width: 200px;
  margin-bottom: 10px;
  display: inline-block;
  object-fit: contain;
  background: #f5f5f5;
  padding: 12px;
}

.imgDragbox {
  text-align: center;
  padding: 20px;
  margin-left: 20px;
  width: 50%;
}

</style>
